import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element.querySelector('#confirmationModal'));
  }

  disconnect() {

  }

  showModal(event) {
    event.preventDefault(); // Prevent form submission or link navigation
    this.modal.show();
  }

  confirm() {
    this.modal.hide();
    // Perform the action, e.g., form submission
    this.element.querySelector('form').submit();
  }
}
